import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom';

import './App.css';

import {Header, Footer, Breadcrumb, Loading} from './components/Body';
import Accueil from './components/Accueil';
import Login from './components/Login';
import Approvisionnements from './components/Approvisionnements';
import Transactions from './components/Transactions';
import Utilisateurs from './components/Utilisateurs';

import {routes} from './config/globales';

import Auth from './Auth';
import Clients from './components/Clients';
import Recharges from './components/Recharge';
import Partenaires from './components/Partenaires';
import EtatFinancier from './components/EtatFinancier';


class App extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      auth: new Auth()
    };
    this.animationTraitement = this.animationTraitement.bind(this);
  }

  componentDidMount() {
    this.setState({loading: false});
  }

  animationTraitement(isAnimated) {
    this.setState({loading: isAnimated});
  }


  render() {
    return (
      <Router>
        <Loading show={this.state.loading} />
        <Header withLogout={this.state.auth.isAuth} auth={this.state.auth} />
        <Switch>
          <Route exact path="/">
            {(this.state.auth.isAuth)?
            <Accueil isLoading={this.animationTraitement} />:<Login auth={this.state.auth} />
            }
          </Route>
          <Route path="/approvisionnements">
            {(this.state.auth.isAuth)?
            <>
            <Breadcrumb text="Approvisionnements" />
            <Approvisionnements isLoading={this.animationTraitement} auth={this.state.auth} />
            </>:
            <Login auth={this.state.auth} />
            }
          </Route>
          <Route path="/transactions">
            {(this.state.auth.isAuth)?
            <>
            <Breadcrumb text="Transactions" />
            <Transactions isLoading={this.animationTraitement} auth={this.state.auth} />
            </>:
            <Login auth={this.state.auth} />
            }
          </Route>
          <Route path="/utilisateurs">
            {(this.state.auth.isAuth)?
            <>
            <Breadcrumb text="Utilisateurs" />
            <Utilisateurs isLoading={this.animationTraitement} auth={this.state.auth} isClients={false} />
            </>:
            <Login auth={this.state.auth} />
            }
          </Route>
          <Route path="/partenaires">
            {(this.state.auth.isAuth)?
            <>
            <Breadcrumb text="Partenaires" />
            <Partenaires isLoading={this.animationTraitement} auth={this.state.auth} isClients={false} />
            </>:
            <Login auth={this.state.auth} />
            }
          </Route>
          <Route path="/finances">
            {(this.state.auth.isAuth)?
            <>
            <Breadcrumb text="Etats Financiers" />
            <EtatFinancier isLoading={this.animationTraitement} auth={this.state.auth} />
            </>:
            <Login auth={this.state.auth} />
            }
          </Route>
          <Route path="/clients">
            {(this.state.auth.isAuth)?
            <>
            <Breadcrumb text="Clients" />
            <Clients isLoading={this.animationTraitement} auth={this.state.auth} isClients={true} />
            </>:
            <Login auth={this.state.auth} />
            }
          </Route>
          <Route path="/recharges">
            {(this.state.auth.isAuth)?
            <>
            <Breadcrumb text="Recharges" />
            <Recharges isLoading={this.animationTraitement} auth={this.state.auth} />
            </>:
            <Login auth={this.state.auth} />
            }
          </Route>
        </Switch>
        <Footer />
      </Router>
    );
  }

}

export default App;